import React, { useState } from 'react'
import Modal from 'react-modal'
import { useToasts } from 'react-toast-notifications'
import '../../styles/modals/SecretKeyModal.css'
import Shield from '../../svg/Shield'
import Times from '../../svg/Times'
import { useTranslation } from 'react-i18next'
import i18n from '../../i18n'

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'transparent',
        border: null,
    },
}

const SecretKeyModal = (props) => {
    const { isOpen, onRequestClose } = props

    const [secretKey, setSecretKey] = useState('')
    const { addToast } = useToasts()
    const { t } = useTranslation()

    const handleSubmit = async (e) => {
        e.preventDefault()
        addToast(t('secretKeyHasBeenSaved'), {
            appearance: 'success',
            autoDismiss: true,
        })
        await localStorage.setItem('secret_key', secretKey)
        onRequestClose()
    }

    return (
        <Modal isOpen={isOpen} onRequestClose={onRequestClose} style={customStyles} ariaHideApp={false} shouldCloseOnOverlayClick={false} shouldCloseOnEsc={false}>
            <div className={`secret-key-modal ${i18n.language === 'ar' ? 'ar-lang' : ''}`}>
                <div className="secret-key-modal-close" onClick={onRequestClose}>
                    <Times />
                </div>
                <div className="secret-key-modal-header">
                    {/* TODO: Izmeniti boju ovog shield */}
                    <Shield fill="#153c4f"/>
                    <h2>{t('staySecuredFirst')}</h2>
                    <p className="modal-attention">
                        <b>{t('Attention')}</b>: {t('toEnsureYourPrivacyThisKeyIsNotRecoverableAllYourNotesWillBeLostIfYouForgetThisKey')}
                    </p>
                </div>

                <div className="secret-key-form">
                    <form onSubmit={handleSubmit}>
                        <fieldset>
                            <label htmlFor="user_secret_key">
                                <p>{t('secretKey')}</p>
                            </label>
                            <input type="password" name="user_secret_key" placeholder={t('enterSecretKey')} value={secretKey} onChange={(e) => setSecretKey(e.target.value)} />
                        </fieldset>

                        <button className="main-button">{t('save')}</button>
                    </form>
                </div>
            </div>
        </Modal>
    )
}

export default SecretKeyModal
